import React from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../Atoms/Button';
import { P4 } from '../../Atoms/Typo';

const Component = styled.div<{ $activeID: number }>`
  display: flex;
  align-items: center;

  button {
    width: 53px;
    height: 28px;
    ${P4} {
      color: ${(props) => props.theme.colors.grey600};
    }

    background-color: ${(props) => props.theme.colors.grey300};

    :first-child {
      border-radius: 8px 0px 0px 8px;
    }
    :last-child {
      border-radius: 0px 8px 8px 0px;
    }
    :not(:last-child) {
      border-right: solid 1px ${(props) => props.theme.colors.white};
    }
  }

  ${(props) => {
    return css`
      button {
        :nth-child(${props.$activeID + 1}) {
          ${P4} {
            color: ${props.theme.colors.blue300};
            /* opacity: 1; */
          }

          background-color: ${props.theme.colors.blue100};
          /* opacity: 0.1; */
        }
      }
    `;
  }}
`;

interface ButtonGroupProps {
  buttonData: {
    id: number;
    title: string;
  }[];
  activeID: number;
  className?: string;
  onClick?: (id: number) => void;
}

const ButtonGroup = ({
  buttonData,
  activeID,
  className,
  onClick,
}: ButtonGroupProps) => {
  const onClickButton = (id: number) => {
    if (onClick) {
      onClick(id);
    }
  };

  return (
    <Component $activeID={activeID} className={className}>
      {buttonData.map((element) => {
        return (
          <Button
            key={element.id}
            onClick={() => {
              onClickButton(element.id);
            }}
          >
            <P4>{element.title}</P4>
          </Button>
        );
      })}
    </Component>
  );
};

export default ButtonGroup;
